import { graphql, useStaticQuery } from 'gatsby';

export default function useUpcomingEvents() {
  const { allUpcomingEventsJson } = useStaticQuery(
    graphql`
      query {
        allUpcomingEventsJson {
          nodes {
            alt
            src {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH)
              }
            }
          }
        }
      }
    `
  );
  return allUpcomingEventsJson.nodes;
}
